export class FreeBookingEvent {
    event: string = 'freeBooking';
    type: string;

    constructor(type: string) {
        this.type = type;
    }
}